import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  Input,
  ElementRef,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FormBuilder, Validators } from '@angular/forms';

type CandidateFile = {
  externalID?: string;
  name?: string;
  fileContent?: string;
  type?: string;
};

type NewFile = {
  id?: number;
  fileUrl?: string;
  type?: string;
  fileStream?: string;
  fileSize?: number;
  fileName?: string;
  fileNameOld?: string;
  dateAdded?: string;
  contentType?: string;
  contentSubType?: string;
};

@Component({
  selector: 'app-candidate-documents',
  templateUrl: './candidate-documents.component.html',
  styleUrls: ['./candidate-documents.component.css'],
})
export class CandidateDocumentsComponent implements OnInit {
  @Input() candidateID: string = '';
  fileInputText: string = 'No File Chosen...';
  @ViewChild('fileChosenUpdate') fileChosenUpdate!: ElementRef;
  @ViewChild('closeModelAdd') closeModelAdd!: ElementRef;
  @ViewChild('closeModelUpdate') closeModelUpdate!: ElementRef;
  @ViewChild('closeModelDelete') closeModelDelete!: ElementRef;
  @ViewChild('TypeAdd') TypeAdd!: ElementRef;
  @ViewChild('TypeUpdate') TypeUpdate!: ElementRef;
  @ViewChild('fileInputAdd') fileInputAdd!: ElementRef;
  loginDisplay = false;
  loadingJobFiles: boolean = true;
  loadingCandidateFiles: boolean = true;
  enableType: boolean = false;
  enableUpload: boolean = false;
  fileError: boolean = false;
  mobileView: boolean = false;
  loading: boolean = false;
  candidate_file!: CandidateFile;
  file_obj!: NewFile;
  path =
    'https://rest61.bullhornstaffing.com/rest-services/2g9m9s/file/Candidate/231585/504294/raw?BhRestToken=74a83c83-759c-4158-8854-6e0c7fdd0769';
  startPage = 1;
  name: any;
  email: any;
  candidateFilesList: any;
  jobFilesList: any;
  updateFileID: any;
  fileName: any;
  fileNameOld: any;
  contentType: any;
  contentSubType: any;
  fileSize!: number;
  typeSelected: any;
  base64: any;
  file: any;
  FileID: any;
  selected: string = 'personal-documents';
  id: string = '';
  index: number = 0;

  editFile = {
    id: 0,
  };

  fileTypes: any[] = [
    {
      value: 'Approval',
      label: 'Approval',
    },
    {
      value: '408 Visa Letter',
      label: '408 Visa Letter',
    },
    {
      value: 'Client Specific Induction',
      label: 'Client Specific Induction',
    },
    {
      value: 'Confirmation of Enrolment',
      label: 'Confirmation of Enrolment',
    },
    {
      value: 'Correspondence',
      label: 'Correspondence',
    },
    {
      value: 'Cover Letter',
      label: 'Cover Letter',
    },
    {
      value: 'Covid Vax Proof',
      label: 'Covid Vax Proof',
    },
    {
      value: 'Feedback',
      label: 'Feedback',
    },
    {
      value: 'Induction',
      label: 'Induction',
    },
    {
      value: 'Letter of Offer',
      label: 'Letter of Offer',
    },
    {
      value: 'Licence',
      label: 'Licence',
    },
    {
      value: 'MADEC Card',
      label: 'MADEC Card',
    },
    {
      value: 'Position Description',
      label: 'Position Description',
    },
    {
      value: 'Proof of Identity',
      label: 'Proof of Identity',
    },
    {
      value: 'Qualification',
      label: 'Qualification',
    },
    {
      value: 'Resume / CV',
      label: 'Resume / CV',
    },
    {
      value: 'VEVO',
      label: 'VEVO',
    },
    {
      value: 'Visa',
      label: 'Visa',
    },
    {
      value: 'Reference',
      label: 'Reference',
    },
    {
      value: 'Risk Assessment',
      label: 'Risk Assessment',
    },
    {
      value: 'Training Record',
      label: 'Training Record',
    },
    {
      value: 'Warning Letter',
      label: 'Warning Letter',
    },
    {
      value: 'Work Instruction/SOP',
      label: 'Work Instruction/SOP',
    },
    {
      value: 'Other',
      label: 'Other',
    },
  ];

  public formGroup = this.fb.group({
    file: [null, Validators.required],
  });

  toggleSidebar() {
    var menu = document.querySelector('.page-container');
    menu?.classList.toggle('sbar_collapsed');
  }

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private authService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      if (window.screen.width <= 768) {
        this.toggleSidebar();
      }
    });
  }

  ngOnInit(): void {
    let api = '/admin/File/GetCandidateFiles/' + this.candidateID;

    this.getCandidateFiles(environment.apiConfig.uri + api);
  }

  ngAfterViewInit() {
    if (window.screen.width <= 768) {
      this.mobileView = true;
    }
  }

  closeModel() {
    this.enableType = false;
    this.enableUpload = false;
    this.fileError = false;
    this.resetForm();
  }

  selectType(event: any) {
    this.typeSelected = event.target.value;
    if (this.typeSelected && this.base64 && !this.fileError) {
      this.enableUpload = true;
    } else {
      this.enableUpload = false;
    }
  }

  public onFileChange(event: any, operation: string) {
    const file = event.target.files[0];
    if (file) {
      this.fileSize = Math.round(file.size / 1024); // Convert to KB
      
      // Check file size (10MB limit)
      if (this.fileSize > 10240) { // 10MB in KB
        this.fileError = true;
        this.enableType = false;
        this.enableUpload = false;
        return;
      }
      
      this.fileError = false;
      this.fileName = file.name;
      this.contentType = file.type.split('/')[0];
      this.contentSubType = file.type.split('/')[1];
      
      // Update the file chosen display
      if (operation === 'add') {
        this.fileInputText = file.name;
      } else if (operation === 'edit' && this.fileChosenUpdate) {
        this.fileChosenUpdate.nativeElement.textContent = file.name;
      }
      
      this.enableType = true;
      
      // Convert file to base64
      const reader = new FileReader();
      reader.onload = () => {
        this.base64 = reader.result as string;
        // Remove the data URL prefix to get just the base64 content
        this.base64 = this.base64.split(',')[1];
      };
      reader.readAsDataURL(file);
    }
  }

  public addFileSubmit(values: any, form: any): void {
    this.loading = true;
    this.enableUpload = false;
    
    const FileObj = <CandidateFile>{};
    FileObj.externalID = 'admin-upload';
    FileObj.fileContent = this.base64;
    FileObj.type = this.typeSelected;
    FileObj.name = this.fileName;
    
    // Use the admin-specific endpoint
    const url = `${environment.apiConfig.uri}/admin/File/AddCandidateFile/${this.candidateID}`;
    
    this.http.post<any>(url, FileObj).subscribe(
      (response: any) => {
        this.loading = false;
        this.closeModelAdd.nativeElement.click();
        this.enableType = false;
        this.resetForm();
        form.resetForm();
        
        // Refresh the candidate files list
        this.getCandidateFiles(`${environment.apiConfig.uri}/admin/File/GetCandidateFiles/${this.candidateID}`);
      },
      (error) => {
        console.error('Error uploading file:', error);
        this.loading = false;
        // Handle error - you might want to show an error message to the user
      }
    );
  }

  // Add method to reset form after successful upload
  resetForm(): void {
    this.fileName = '';
    this.typeSelected = '';
    this.base64 = '';
    this.fileSize = 0;
    this.enableType = false;
    this.enableUpload = false;
    this.fileInputText = 'No File Chosen...';
    this.fileError = false;
    
    // Reset the select dropdown
    if (this.TypeAdd) {
      this.TypeAdd.nativeElement.selectedIndex = 0;
    }
    
    // Clear the file input
    if (this.fileInputAdd) {
      this.fileInputAdd.nativeElement.value = '';
    }
  }

  // Add method to open add file modal
  addFile(): void {
    this.resetForm();
  }

  updateFile(item: any, index: number) {
    this.updateFileID = item.id;
    this.fileNameOld = item.fileName;
    this.editFile = item;
    this.index = index;
  }

  public updateFileSubmit(event: any, FileId: any, index: number): void {
    this.loading = true;
    this.enableUpload = false;
    const FileObj = <CandidateFile>{};
    const UpdateObj = <NewFile>{};
    FileObj.fileContent = this.base64;
    FileObj.name = this.fileName;
    FileObj.externalID = 'portoflio';
    FileObj.type = this.typeSelected;
    UpdateObj.fileStream = this.base64;
    UpdateObj.fileName = this.fileName;
    UpdateObj.type = this.typeSelected;
    UpdateObj.contentType = this.contentType;
    UpdateObj.contentSubType = this.contentSubType;
    UpdateObj.id = FileId;
    UpdateObj.fileSize = this.fileSize;
    UpdateObj.dateAdded = Date.now().toString();
    var url = environment.apiConfig.uri + `/admin/File/UpdateCandidateFile/${this.candidateID}/${this.updateFileID}`;
    this.http.put<any>(url, FileObj).subscribe((response: any) => {
      this.closeModelUpdate.nativeElement.click();
      this.enableType = false;
      this.candidateFilesList[index] = UpdateObj;
      this.loading = false;
    });
    // this.loading = false;

  }


  deleteFileRequest(FileID: any, index: number): void {
    this.FileID = FileID;
    this.index = index;
  }

  deleteFile(event: any, FileID: any, index: number): void {
    var url = environment.apiConfig.uri + `/admin/File/${FileID}/${this.candidateID}`;
    this.loading = true;

    this.http.delete(url).subscribe(
      (response: any) => {
        this.candidateFilesList.splice(index, 1);
        this.FileID = null;
        this.index = 0;
        this.closeModelDelete.nativeElement.click();
      },
      (error) => {
        // console.log('error:', error);
      }
    );
  }

  updateClientDate = async () => {
    this.candidateFilesList = this.candidateFilesList.map((file: any) => {
      const date = new Date(file.dateAdded);
      const offset = date.getTimezoneOffset() * 60 * 1000;
      const newEpoch = date.getTime() - offset;
      const newDate = new Date(newEpoch);
      file.clientDate = newDate;
      return file;
    });
  };

  getCandidateFiles = (url: string) => {
    this.http.get(url).subscribe(async (response: any) => {
      this.candidateFilesList = response.data;
      await this.updateClientDate();
      this.loadingCandidateFiles = false;
    });
  };

  onClickDownload(item: any) {
    if (!item.fileStream) {
      this.getFileStream(item);
    } else {
      const link = document.createElement('a');
      link.download = `${item.fileName}`;
      const source = `data:${item.contentType}/${item.contentSubType=='octet-stream'?'pdf':item.contentSubType};base64,${item.fileStream}`;
      link.href = source;
      link.click();
    }
  }

  download(item: any) {
    const link = document.createElement('a');
    link.download = `${item.fileName}`;
    const source = `data:${item.contentType}/${item.contentSubType=='octet-stream'?'pdf':item.contentSubType};base64,${item.fileStream}`;
    link.href = source;
    link.click();
  }

  onClickView(item: any) {
    if (!item.fileStream) {
      this.getFileStream(item, true);
    } else {
      const link = document.createElement('a');
      link.target = '_blank';
      const Blob = this.dataURItoBlob(item);
      const file = new File([Blob], item.fileName, {
        type: `${item.contentType}/${item.contentSubType=='octet-stream'?'pdf':item.contentSubType}`,
      });
      let url = window.URL.createObjectURL(file);
      link.href = url;
      link.click();
    }
  }

  getFileStream(item: any, view: boolean = false) {
    var url = environment.apiConfig.uri + `/admin/File/GetFileStream/Candidate/${item.id}`;
    this.http.get(url).subscribe((response: any) => {
      this.file = response.data ? response.data : '$';
      item.fileStream = this.file;
      if (view == true) {
        this.onClickView(item);
      } else {
        this.onClickDownload(item);
      }
    });
  }

  dataURItoBlob(item: any) {
    const byteString = window.atob(item.fileStream);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {
      type: `${item.contentType}/${item.contentSubType=='octet-stream'?'pdf':item.contentSubType}`,
    });
    return blob;
  }
}
